import { render, staticRenderFns } from "./orderPerformersGift.vue?vue&type=template&id=474c9748&scoped=true&"
import script from "./orderPerformersGift.vue?vue&type=script&lang=js&"
export * from "./orderPerformersGift.vue?vue&type=script&lang=js&"
import style0 from "./orderPerformersGift.vue?vue&type=style&index=0&id=474c9748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474c9748",
  null
  
)

export default component.exports